import React from "react";

function CheckoutBtn() {
  return (
    <div className="checkout" tabIndex="0">
      <button className="checkout__btn">Checkout</button>
    </div>
  );
}

export default CheckoutBtn;
